import type { AddTagAction as AddTagActionType } from "@redotech/redo-flows-common/rules/schemas";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";
import { RuleTagPicker } from "../../rule-tag-picker";

export const AddTagAction = memo(function AddTagAction({
  action,
  onChange,
  editableFields,
}: {
  action: AddTagActionType;
  onChange: (updated: AddTagActionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const tagEditable = editableFields === undefined || editableFields.has("tag");

  const tagNames = useMemo(() => {
    if (Array.isArray(action.tag)) {
      return action.tag;
    }
    return action.tag ? [action.tag] : [];
  }, [action.tag]);

  return (
    <Flex dir="column" gap="sm" w="full">
      <Flex
        style={
          tagEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <RuleTagPicker
          onChange={(names) => onChange({ ...action, tag: names })}
          selectedTagNames={tagNames}
        />
      </Flex>
    </Flex>
  );
});
